import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import MultipleSelectChip from "../fields/chips";

export default function FondoTrust({
    setInfoAggiuntive, 

    setElencoBeni,
    ElencoBeni,
    setValoreAppBeni,
    }) {
    
    const beni = [
        'Immobili',
        'Titoli',
        'Beni mobili registrati'
    ];

	return (
		<>
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab'>Beni</label>
                    <p>Selezionare tutte le caselle rilevanti</p>
                    <MultipleSelectChip 
                        names={beni} 
                        setElement={setElencoBeni}
                        Element={ElencoBeni}
                    />
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <div className="field">
                    <label className='customLab' for="from_name">Qual è il valore approssimativo dei beni da vincolare?</label>
                    <input type="number" placeholder="100000" name="valoreAppBeniVincolare" id="valoreAppBeniVincolare" onChange={e => setValoreAppBeni(e.target.value)} />
                </div>
            </MDBRow>
            
            <MDBRow>
                <div className="field">
                    <label className='customLab' for="message">Informazioni aggiuntive</label>
                    <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                </div>
            </MDBRow>

            </>
	);
}